export const siteConfig = {
  name: 'Rastreio Político',
  subject: 'arquivo documental',
  tagline: 'A fonte é pública. O histórico também.',
  description: 'Arquivos documentais de políticos brasileiros: falas, documentos, relações e mudanças de versão organizados para comparação pública.',
  baseUrl: 'https://rastreiopolitico.org',
  correctionsEmail: 'zeroeum@tuta.io',
  lastEditorialReview: '2026-10-21',
  contentVersion: 'acervo atualizado em 21/10/2026',
  nameAlternatives: ['Arquivo do Rastro', 'Linha Pública', 'Documento Aberto'],
} as const
